import React, { useState, useEffect } from "react"
import {
  Container,
  Input,
  Label,
  FormGroup,
  Form,
  Button,
  Row,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "reactstrap"
import axios from "axios"
import { Link } from "react-router-dom"
import Spinner from "../Spinner"

const APIserver = "https://hdform.herokuapp.com/api/facility/"

const EditFacility = (props) => {
  const [data, setData] = useState([])
  const [name, setName] = useState("")
  const [mobile, setMobile] = useState("")
  const [email, setEmail] = useState("")
  const [address, setAddress] = useState("")
  const [loading, setLoading] = useState(false)

  // Modal handlers
  const [open, setOpen] = useState(false)
  const [focusAfterClose, setFocusAfterClose] = useState(true)
  const showModal = () => setOpen(true)

  function getFacilityData() {
    fetch(APIserver + props.match.params.id)
      .then((res) => res.json())
      .then((res) => {
        setData(res)
        setName(res.name)
        setMobile(res.mobile)
        setEmail(res.email)
        setAddress(res.address)
        setLoading(false)
      })
  }

  useEffect(() => {
    setLoading(true)
    getFacilityData()
  }, [])

  const submitEdits = (e) => {
    setLoading(true)
    e.preventDefault()
    const editedFacility = {
      name: name,
      email: email,
      mobile: mobile,
      address: address,
    }
    axios
      .post(APIserver + "edit/" + props.match.params.id, editedFacility)
      .then((res) => setLoading(false))
      .catch((err) => {
        console.log(err)
      })
      .finally((res) => {
        window.location.replace("/admin")
      })
  }

  const deleteFacility = () => {
    setLoading(true)
    axios
      .delete(APIserver + "delete/" + props.match.params.id)
      .then((res) => {
        console.log(`${props.match.params.id} has been deleted!`)
      })
      .catch((err) => console.log(`Error: ${err}`))
      .finally((res) => {
        setOpen(false)
        window.location.replace("/admin")
      })
  }

  function DeleteConfirmationModal() {
    return (
      <Container>
        <Modal returnFocusAfterClose={focusAfterClose} isOpen={open}>
          <ModalHeader className="success-modal-header text-center">
            Action Required!
          </ModalHeader>
          <ModalBody>
            Proceed in deleting this record? This record could no longer be
            recovered once deleted.
          </ModalBody>
          <ModalFooter>
            <Row>
              <Button color="danger" onClick={deleteFacility}>
                YES, delete this record
              </Button>
              <Button onClick={() => setOpen(false)}>CANCEL</Button>
            </Row>
          </ModalFooter>
        </Modal>
      </Container>
    )
  }

  return (
    <Container className="edit-page">
      <Link to="/admin">
        <Button color="secondary">Back</Button>
      </Link>
      {loading === true ? (
        <Spinner />
      ) : (
        <div className="edit-form">
          <h1>Editing Facility Details</h1>
          <Form onSubmit={submitEdits} className="edit-form">
            <FormGroup>
              <Label>Facility Name</Label>
              <Input
                required
                value={name}
                onChange={(e) => setName(e.target.value)}
                type="text"
              />
            </FormGroup>
            <FormGroup>
              <Label>Address</Label>
              <Input
                required
                onChange={(e) => setAddress(e.target.value)}
                value={address}
                type="text"
              />
            </FormGroup>
            <FormGroup>
              <Label>Mobile No.</Label>
              <Input
                required
                onChange={(e) => setMobile(e.target.value)}
                value={mobile}
                type="tel"
              />
            </FormGroup>
            <FormGroup>
              <Label>Email Address</Label>
              <Input
                required
                onChange={(e) => setEmail(e.target.value)}
                value={email}
                type="email"
              />
            </FormGroup>
            <FormGroup>
              <p> Created: {new Date(data.createdAt).toLocaleString()}</p>
            </FormGroup>
            <Container>
              <Row>
                <Button color="primary" onClick={submitEdits}>
                  Submit Edits
                </Button>
                <Button color="danger" onClick={showModal}>
                  Delete this record
                </Button>
              </Row>
            </Container>
          </Form>
        </div>
      )}
      <DeleteConfirmationModal />
    </Container>
  )
}

export default EditFacility
